import React from "react";
import pluralize from "pluralize";
import { number, string } from "prop-types";

import * as S from "./styled";

const AgentExperience = ({
  className,
  medianSalesPrice,
  recentHomesSold,
  yearsExperience
}) => (
  <div className={className}>
    <S.List>
      <S.ItemContainer>
        {Boolean(recentHomesSold) && (
          <S.ListItem>
            {pluralize("home", recentHomesSold, true)} sold in the last 5 years
          </S.ListItem>
        )}
      </S.ItemContainer>
      <S.ItemContainer>
        {Boolean(medianSalesPrice) && (
          <S.ListItem>{medianSalesPrice} median sale price</S.ListItem>
        )}
      </S.ItemContainer>
      <S.ItemContainer>
        {Boolean(yearsExperience) && (
          <S.ListItem>
            {pluralize("year", yearsExperience, true)} on StreetEasy
          </S.ListItem>
        )}
      </S.ItemContainer>
    </S.List>
  </div>
);

AgentExperience.propTypes = {
  className: string,
  medianSalesPrice: string,
  recentHomesSold: number,
  yearsExperience: number
};

AgentExperience.defaultProps = {
  className: "",
  medianSalesPrice: "",
  recentHomesSold: null,
  yearsExperience: null
};

export default AgentExperience;
